import React from "react";
import { Stack, Typography } from "@mui/material";

/**
 * 共通エラー画面
 * @returns
 */
const Error = () => {
  return (
    <Stack
      spacing={2}
      sx={{
        width: "100%",
        textAlign: "center",
        paddingTop: "30vh",
      }}
    >
      <Typography variant="h2">500</Typography>
      <Typography>システムエラーが発生しました。</Typography>
    </Stack>
  );
};
export default Error;
